import React, { useState } from 'react';
import { Unlink, Link2 } from 'lucide-react';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import { TrainingLinkPicker, trainingError } from './TrainingLinkPicker';

// Link header only. Athlete edits and their sole draft state live in the table.
export const TrainingDurationPanel = ({ api, event, context, error, language, onUpdate, disabled, canEdit }) => {
  const [picker, setPicker] = useState({ training_link_mode: 'NONE' });
  const [busy, setBusy] = useState(false);
  const [linkError, setLinkError] = useState('');
  const t = (it, en) => language === 'IT' ? it : en;
  const run = async (work) => {
    if (busy || disabled) return;
    setBusy(true); setLinkError('');
    try {
      await work(); await onUpdate();
      setPicker({ training_link_mode: 'NONE' });
      toast.success(t('Collegamento aggiornato', 'Link updated'));
    } catch (e) { setLinkError(trainingError(e, language)); }
    finally { setBusy(false); }
  };
  return <section className="border-y border-zinc-700 py-3 space-y-3 min-w-0" data-testid="training-link-header">
    {(error || linkError) && <p role="alert" className="text-sm text-red-400" data-testid="training-duration-error">{error || linkError}</p>}
    {!context && !error && <p data-testid="training-duration-loading">{t('Caricamento Planner…', 'Loading Planner…')}</p>}
    {context?.planner_session_id ? <div className="flex flex-wrap items-center justify-between gap-3">
      <p className="text-sm text-zinc-300 break-words min-w-0" data-testid="training-linked-session">
        <span className="text-emerald-300">Planner · </span>
        {context.planner_title || t('Sessione non disponibile', 'Session unavailable')} · {context.planner_duration_min ?? '—'} min
      </p>
      {canEdit && <Button size="sm" variant="outline" disabled={busy || disabled} data-testid="training-unlink-button"
        onClick={() => run(() => api.patch(`/gps/events/${event.id}/unlink-planner`))}>
        <Unlink className="w-4 h-4 mr-2" />{t('Scollega', 'Unlink')}
      </Button>}
    </div> : context && <>
      <p className="text-xs text-zinc-400" data-testid="training-independent-status">{t('TRAINING indipendente', 'Independent TRAINING')}</p>
      {canEdit && <>
        <TrainingLinkPicker api={api} language={language} teamId={event.team_id} date={event.date} value={picker}
          onChange={p => setPicker(v => ({ ...v, ...p }))} prefix="training-detail-link" allowCreate={false} disabled={busy || disabled} />
        {picker.training_link_mode === 'LINK_EXISTING' && <Button size="sm" disabled={busy || disabled || !picker.training_planner_id} data-testid="training-link-save"
          onClick={() => run(() => api.patch(`/gps/events/${event.id}/link-planner`, { planner_session_id: picker.training_planner_id }))}>
          <Link2 className="w-4 h-4 mr-2" />{t('Collega', 'Link')}
        </Button>}
      </>}
    </>}
  </section>;
};